export default __webpack_public_path__ + "static/media/20-marina-gallo-ophiuchus-jewels-paine-chile-travel-diary.2aab20b3.jpg";